import * as React from 'react';

import ReactMarkdown from 'react-markdown';

import './Motd.scss';

import Button from 'common/components/core/Button/Button';
import Icons from 'common/icons';

export interface MotdProps {
  onAccept: () => void;
  children: string;
}

/**
 * MOTD - message of the day, usually used to describe message that's show
 * upon logging in Linux servers. We conditionally need to show this message
 * upon user login.
 */
export default function Motd({ children, onAccept }: React.PropsWithChildren<MotdProps>) {
  return (
    <div className="onboarding">
      <div className="onboarding-box">
        <h2 className="onboarding-title mb-l text-error">WARNING</h2>

        <ReactMarkdown source={children} escapeHtml={true} linkTarget="_blank" />

        <div className="mt-l">
          <Button fullWidth={true} onClick={onAccept}>
            I accept
          </Button>
        </div>

        <img className="onboarding-box__logo" src={Icons.NUTANIX_TYPE_LIGHT} alt="Nutanix" />
      </div>
    </div>
  );
}
